/* Auto-generated from inline schema 2025-08-29T08:39:05.739Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: ['yes_no'],
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
